import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from '../app.component';

// PrimeNG Components for demos
import { PrimeNGModule } from 'src/app/shared/primeng.module';

import { MarkAsteriskDirectiveModule } from '../directives/mark-asterisk.directive';

import { FacturasRoutingModule } from './facturas-routing.module';

import { FacturaServicioComponent } from './factura-servicio/factura-servicio.component';
import { FAZILService } from '../core';
import { UIService } from '../core/services/ui.service';
import { FacturasService } from './facturas.service';
import { FacturaPopupComponent } from './factura-popup/factura-popup.component';
import { FacturaResolver } from './factura-resolver.service';
import { FacturaDuplicarResolver } from './factura-duplicar-resolver.service';
import { FacturaServicioRecibidasComponent } from './factura-servicio-recibidas/factura-servicio-recibidas.component';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NotadecreditoPopupComponent } from './notadecredito-popup/notadecredito-popup.component';
import { NotadecreditoServicioRecibidasComponent } from './notadecredito-servicio-recibidas/notadecredito-servicio-recibidas.component';
import { NotadecreditoServicioComponent } from './notadecredito-servicio/notadecredito-servicio.component';
import { RetencionPopupComponent } from './retencion-popup/retencion-popup.component';
import { RetencionServicioComponent } from './retencion-servicio/retencion-servicio.component';
import { GuiaRemisionComponent } from './guia-remision/guia-remision.component';
import { SharedModule } from '../shared';
import { ProformaResolver } from './proforma-resolver.service';
import { ContactosModule } from '../contactos/contactos.module';
import { ServiciosModule } from '../servicios/servicios.module';

@NgModule({
    declarations: [ 
        FacturaServicioComponent, 
        FacturaPopupComponent, 
        FacturaServicioRecibidasComponent,
        NotadecreditoPopupComponent, 
        NotadecreditoServicioRecibidasComponent, 
        NotadecreditoServicioComponent,
        RetencionPopupComponent, 
        RetencionServicioComponent,
        GuiaRemisionComponent
        ],
    bootstrap: [AppComponent],
    imports: [
        CommonModule,
        PrimeNGModule,
        MarkAsteriskDirectiveModule,
        FormsModule,
        ReactiveFormsModule,
        FacturasRoutingModule,
        PdfViewerModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatIconModule,
        MatFormFieldModule,
        SharedModule,
        ContactosModule,
        ServiciosModule
    ],
    providers: [
        FacturasService,
        FacturaResolver,
        ProformaResolver,
        FacturaDuplicarResolver
    ]
})
export class FacturasModule { }
